import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Theme } from '@material-ui/core';


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        marginTop: 150,
        padding: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
    },
    image: {
        display: 'inline-block',
        marginTop: 50,
        maxWidth: '100%',
        width: 560
    }
}));

const Error403 = (props: any) => {
    const classes = useStyles(props);

    return (
        <div className={classes.root}>
            <Typography
                align="center"
                variant="h1"
            >
                403: Sorry, we're unable to authenticate your user
            </Typography>
            <Typography
                align="center"
                variant="subtitle2"
            >
                You either tried some shady route or you came here by mistake. Whichever it is, try to login again or contact support
            </Typography>
            <img
                alt="401 unautorized access"
                className={classes.image}
                src="/images/error/401.svg"
            />
        </div>
    );
};

export default Error403;
